module.exports = __webpack_public_path__ + "static/media/explore-3.78b5c275.jpeg";